import { schema } from 'normalizr';
export const leadTagSchema = new schema.Entity(
  'leadTag',
  {},
  {
    processStrategy: value =>
      value.reduce(
        (acc: any, item: any) => ({ ...acc, [item.tagId]: item }),
        {}
      ),
  }
);
